import './site';

const app = document.querySelector('#app');
if (!app) throw new Error('No se encontró el punto de montaje de la aplicación.');
if (window.location.pathname === '/admin') {
  app.innerHTML = '<daniel-admin></daniel-admin>';
  void import('./admin');
} else {
  app.innerHTML = '<daniel-site></daniel-site>';
}
